import { render, staticRenderFns } from "./VenaSealPage.vue?vue&type=template&id=aa52fb9c&scoped=true"
import script from "./VenaSealPage.vue?vue&type=script&lang=js"
export * from "./VenaSealPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa52fb9c",
  null
  
)

export default component.exports